import React from 'react';
import { hot } from 'react-hot-loader/root';
import { Heading } from '@charlietango/ui';

import LinkViewModel from '../../view-models/LinkViewModel';
import TextBlockViewModel from '../../view-models/TextBlockViewModel';

export type ContactPageProps = {
  intro?: TextBlockViewModel;
  contact?: {
    title?: string;
    address?: string;
    phone?: LinkViewModel;
    phoneHours?: string;
    email?: LinkViewModel;
  };
};

export function ContactPage(props: ContactPageProps) {
  return (
    <div>
      <img
        alt="under construction"
        width="568"
        height="42"
        src="/dummy/under-construction.gif"
      />
      <Heading>Props</Heading>
      <pre>
        <code>{JSON.stringify(props, null, 2)}</code>
      </pre>
    </div>
  );
}

ContactPage.displayName = 'ContactPage';

export default !process.env.HOT ? ContactPage : hot(ContactPage);
